document.addEventListener('DOMContentLoaded', function(){
	// FAQ accordion for hsafsa.liquid: <faq> root with .faq-item/.faq-question/.faq-answer
	var faqRoot = document.querySelector('#hsa-fsa-faqs');
	if (faqRoot) {
		var items = faqRoot.querySelectorAll('.faq-item');
		items.forEach(function(item){
			var question = item.querySelector('.faq-question');
			var answer = item.querySelector('.faq-answer');
			if (!question || !answer) return;

			// initial state
			answer.style.display = 'none';
			item.setAttribute('aria-expanded', 'false');
			question.setAttribute('role', 'button');
			question.setAttribute('tabindex', '0');

			var toggle = function(){
				var isVisible = answer.style.display === 'block';
				// close others
				items.forEach(function(other){
					if (other !== item) {
						var otherAnswer = other.querySelector('.faq-answer');
						if (otherAnswer) otherAnswer.style.display = 'none';
						other.setAttribute('aria-expanded', 'false');
					}
				});
				// toggle current
				answer.style.display = isVisible ? 'none' : 'block';
				item.setAttribute('aria-expanded', isVisible ? 'false' : 'true');
			};

			question.addEventListener('click', toggle);
			question.addEventListener('keydown', function(e){
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggle();
				}
			});
		});
	}

	// Smooth scroll for in-page anchors within this section only
	document.querySelectorAll('.hsa-fsa-section a[href^="#"]').forEach(function(a){
		a.addEventListener('click', function(e){
			var targetId = a.getAttribute('href').slice(1);
			var target = document.getElementById(targetId);
			if(target){
				e.preventDefault();
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		});
	});
});

